import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

/**
 * Serviço opcional para notificar quando um fluxo (FlowModal) foi concluído.
 * Usado pelo TemplateDetailComponent: o canvas injeta este serviço (se presente)
 * e chama onFlowComplete() no callback do dialog; o detail subscreve e emite saving.
 */
@Injectable()
export class FlowCompletionNotifyService {
  private readonly flowComplete$ = new Subject<void>();

  /** Emitido quando o modal de fluxo fecha (após conclusão). */
  get onFlowComplete$() {
    return this.flowComplete$.asObservable();
  }

  /** Chamar no callback do openGenericDialog(FlowModalComponent, ...) quando o fluxo terminar. */
  notifyFlowComplete(): void {
    this.flowComplete$.next();
  }
}
